import React from 'react'

const NoteContext = React.createContext({})
export const NoteProvider = NoteContext.Provider
export default NoteContext